import {
  formatDateForInput,
  formatDateTimeForInput,
} from '../../../common/util/dateUtil'

export const DEFAULT_DASHBOARD_SEARCH_FILTERS = {
  scacs: [],
  origin_ids: [],
  critical_departure_start_time: '',
  critical_departure_end_time: '',
  arrival_start_time: '',
  arrival_end_time: '',
  start_from_date: '',
  start_to_date: '',
  load_statuses: [],
}

export const DEFAULT_MM_DASHBOARD_SEARCH_FILTERS = () => {
  const defaultStartTime = formatDateTimeForInput(
    new Date(new Date().setDate(new Date().getDate() - 1)).setHours(8, 0, 0, 0),
  )
  const defaultEndTime = formatDateTimeForInput(
    new Date().setHours(7, 59, 0, 0),
  )
  return {
    ...DEFAULT_DASHBOARD_SEARCH_FILTERS,
    arrival_start_time: defaultStartTime,
    arrival_end_time: defaultEndTime,
    selected_filters: ['arrival_start_time', 'arrival_end_time'],
  }
}

export const DEFAULT_PICKUP_SEARCH_FILTERS = () => {
  const today = new Date()

  const threeDaysInFuture = new Date()
  threeDaysInFuture.setDate(today.getDate() + 3)

  return {
    ...DEFAULT_DASHBOARD_SEARCH_FILTERS,
    start_from_date: formatDateForInput(today),
    start_to_date: formatDateForInput(threeDaysInFuture),
    selected_filters: ['start_from_date', 'start_to_date'],
  }
}
